import autoSizeFromParentBoundsFactory from 'components/auto-size-from-parent-bounds';
import MapItem from './map-item';
import GeospatialItem from './geospatial-item';
import GeospatialLegends from './geospatial-legends';

import GeoscatterMapItem from './geoscatter-map-item';
import GeoheatMapItem from './geoheatmap-map-item';
import GeochoroplethItem from './geochoropleth-map-item';

const GeospatialItemWithAutoSize = autoSizeFromParentBoundsFactory(
  GeospatialItem
);

export default GeospatialItemWithAutoSize;
export {
  GeospatialItemWithAutoSize as GeospatialItem,
  GeoscatterMapItem,
  GeoheatMapItem,
  GeochoroplethItem,
  GeospatialLegends,
  MapItem,
};
